import axios from 'axios';
import React, { useState } from 'react';
import { ErrorAlert, SuccessAlert } from '../../utils/Alerts';
import SupportModal from './SupportModal';

const SupportModalContainer = ({
  open,
  onClose,
}) => {
  const [isSendingLoading, setIsSendingLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSend = () => {
    const data = {
      Email: email,
      Subject: 'Support',
      Message: message,
      TechInfo: ` Письмо с сайта ККБ-2. Support.
${navigator.appName}, ${navigator.appVersion}
Телефон пользователя: ${sessionStorage.getItem('forgot_userName')}
Location: ${window.location}`,
      PersonFio: '',
      PersonPhone: '',
      Files: [],
    }

    var boundary = String(Math.random()).slice(2);
    var boundaryMiddle = '--' + boundary + '\r\n';
    var boundaryLast = '--' + boundary + '--\r\n'

    var body = ['\r\n'];
    for (var key in data) {
      body.push('Content-Disposition: form-data; name="' + key + '"\r\n\r\n' + data[key] + '\r\n');
    }

    body = body.join(boundaryMiddle) + boundaryLast;

    try {
      setIsSendingLoading(true);
      axios.post(`${process.env.REACT_APP_API}api/v1.0/support/emailWithoutAuth`, body, {
        headers: {
          accept: "*/*",
          "Accept-Language": "ru-RU",
          'Content-Type': 'multipart/form-data; boundary=' + boundary,
          Project: "Medis",
        }
      })
        .then((res) => {
          onClose();
          setEmail('');
          setMessage('');
          setSuccessMessage('Сообщение отправлено. Спасибо за обращение!');
          setIsSendingLoading(false);
        })
        .catch((err) => {
          let errorString;
          for (const key in err?.response?.data) {
            if (Object.hasOwnProperty.call(err?.response?.data, key)) {
              const element = err?.response?.data[key];
              errorString = `${key}: ${element.join(', ')}`
            }
          }
          setErrorMessage(JSON.stringify(errorString));
          setIsSendingLoading(false);
        })
    } catch (err) { }
  }

  const handleCloseSupportPopup = () => {
    onClose();
    setMessage('');
  }

  return (
    <>
      {successMessage && <SuccessAlert successMessage={successMessage} setSuccessMessage={setSuccessMessage} />}
      {errorMessage && <ErrorAlert errorMessage={errorMessage} setErrorMessage={setErrorMessage} />}
      <SupportModal
        open={open}
        onClose={handleCloseSupportPopup}
        handleSend={handleSend}
        sendingLoading={isSendingLoading}
        email={email}
        setEmail={setEmail}
        message={message}
        setMessage={setMessage}
      />
    </>
  )
}

export default SupportModalContainer;
